import React, { useEffect, useRef, useState } from "react";
import styles from "./Inbox.module.css";
import active from "../../assets/activeIcon.png";
import { List } from "antd";
import { useNavigate } from "react-router-dom";
import engineer from "../../assets/profile2.png";
import engineer2 from "../../assets/man1.png";
import engineer3 from "../../assets/woman1.png";
import engineer5 from "../../assets/man2.png";
import engineer6 from "../../assets/woman2.png";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ChatMiddleware from "../../store/Middlewares/ChatMiddleware";
import { IMG_URL } from "../../store/Apis";
import dummyImg from '../../assets/dummy.png';
import moment from "moment";
import { SearchInput } from "../../components";

function Inbox() {
  const navigate = useNavigate();

  useEffect(() => {
    getChatIndex();
    getLanguage();
  }, [])

  const { t, i18n } = useTranslation();
  const dispatch = useDispatch()
  const ChatIndexList = useSelector(state => state.ChatReducer.ChatIndexList)
  const ChatIndexListPagination = useSelector(state => state.ChatReducer.ChatIndexListPagination)
  const user = useSelector(state => state.AuthReducer.user)
  const [search, setSearch] = useState('')
  const timeout = useRef(null);

  const getChatIndex = () => {
    let data = {
      search: search,
      next_page_url: undefined
    }
    dispatch(ChatMiddleware.getChatIndex(data))
  }

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem('@selectedLanguage');
      i18n.changeLanguage(language)
    } catch (e) {
      console.log(e)
    }
  };

  const onSearch = (text) => {
    let data = {
      search: text,
      next_page_url: undefined
    }
    setSearch(text);
    clearTimeout(timeout.current)
    timeout.current = setTimeout(() => {
      dispatch(ChatMiddleware.getChatIndex(data))
    }, 1000);
  }

  const onPressLoadMore = () => {
    let data = {
      next_page_url: ChatIndexListPagination?.next_page_url,
      search: search,
    };
    dispatch(ChatMiddleware.getChatIndex(data))
  };

  const loadMore =
    ChatIndexListPagination?.next_page_url ? (
      <div
        style={{
          textAlign: 'center',
          marginTop: 12,
          height: 32,
          lineHeight: '32px',
          display: 'flex', justifyContent: 'center'
        }}
      >
        <button onClick={onPressLoadMore} className={styles.loadMore_button}>
          Load More
        </button>
      </div>
    ) : null;


  const renderItem = (item) => {
    let userDetails = null
    if (item?.to_user?.id == user?.id) {
      userDetails = item?.from_user;
    } else if (item?.from_user?.id == user?.id) {
      userDetails = item?.to_user;
    }
    console.log('item', item)
    return (
      <div
        className={styles.message_item}
        onClick={() => navigate("/chat/Chat", { state: item })}
      >
        <div className={styles.flex}>
          <div className={styles.profilecontainer}>
            <img src={userDetails?.profile_image ? IMG_URL + userDetails?.profile_image : dummyImg} className={styles.image} />
            <img src={active} className={styles.active_icon} />
          </div>
          <div className={styles.heading_view}>
            <div>
              <text style={{textTransform:'capitalize'}} className={styles.heading}>{userDetails?.name}</text>
              <text style={{marginLeft:'10px',textTransform:'capitalize'}} className={styles.span}>{'( '+userDetails?.role+' )'}</text>
            </div>
            <text className={styles.span}>{item?.last_message?.message}</text>
            {/* <text className={styles.span}>{item?.category}</text> */}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-end",
            width: "30%",
          }}
        >
          <text className={styles.span} style={{ marginBottom: "5%" }}>
            {item?.last_message?.time ? moment(item?.last_message?.time).format('hh:mm A') : moment().format('hh:mm A')}
          </text>
          {/* {item?.last_message?.message !== "No Message" ? (
            <div className={styles.message_no_view}>
              <text className={styles.span}>{item?.message_count}</text>
            </div>
          ) : null} */}
        </div>
      </div>
    );
  };

  return (
    <div className={styles.home_mainContainer}>
      <h1 className={styles.main_heading}>{t("Inbox")}</h1>
      <div className={styles.used_search_input}>
        <SearchInput
          placeholder={t("Search")}
          onChange={(e) => onSearch(e.target.value)}
        />
      </div>
      <List dataSource={ChatIndexList} footer={loadMore} renderItem={renderItem} />
    </div>
  );
}

export default Inbox;
